import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCROLL_PREFIXES = ["/apply", "/privacy"];

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        const shouldScroll = SCROLL_PREFIXES.some((p) =>
            pathname === p || pathname.startsWith(`${p}/`),
        );
        if (shouldScroll) {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
    }, [pathname]);
    return null;
}
